import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grey lighten-5 px-4 py-4 scroll-wrapper" };
const _hoisted_2 = { class: "require-field-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_HistoryItem = _resolveComponent("HistoryItem");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_CommonScroll = _resolveComponent("CommonScroll");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        scrollable: "",
        transition: "scale-transition"
    }, {
        activator: _withCtx(({ props }) => [
            _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)), undefined, true)
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, {
                flat: "",
                tile: ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}order_history_detail`),
                        "on-cancel": _ctx.handleClickOk
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (_ctx.isOrderHistoryExist)
                                ? (_openBlock(), _createBlock(_component_CommonScroll, {
                                    key: 0,
                                    items: _ctx.orderHistory
                                }, {
                                    item: _withCtx(({ item, index: key }) => [
                                        (_openBlock(), _createBlock(_component_HistoryItem, {
                                            key: key,
                                            item: item
                                        }, null, 8 /* PROPS */, ["item"])),
                                        (!_ctx.isLastItem(key))
                                            ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["items"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createCommentVNode(" 상세이력이 없는 경우 "),
                                    _createElementVNode("div", null, [
                                        _createVNode(_component_v_card_title, { class: "text-body-1 brg-color-grey-600" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}no_order_history_detail_list_info`)), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        ])
                    ]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_DialogFooter, {
                        "ok-only": true,
                        "on-ok": _ctx.handleClickOk
                    }, null, 8 /* PROPS */, ["on-ok"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue"]));
}
